import { render } from "./Image_cropper_multiple.vue?vue&type=template&id=5270a142&scoped=true"
import script from "./Image_cropper_multiple.vue?vue&type=script&lang=js"
export * from "./Image_cropper_multiple.vue?vue&type=script&lang=js"

import "./Image_cropper_multiple.vue?vue&type=style&index=0&id=5270a142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5270a142"]])

export default __exports__